// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"b95d053c","436":"a91b1270","610":"88a5f7bd"}[chunkId] + ".css";
};